import React, { Component } from 'react'
import {Col, Row, Button, Container} from "reactstrap";
import { inject, observer } from "mobx-react";
import DataWrapper from "../../principal/containers/DataWrapper";
import AnaliseCriticaStore from "../stores/AnaliseCriticaStore";
import FiltrosAnaliseCriticaStore from "../stores/FiltrosAnaliseCriticaStore";
import {FiltrosAnaliseCritica} from "../components/FiltrosAnaliseCritica";
import {TabelaAnaliseCritica} from "../components/TabelaAnaliseCritica";
import AnaliseCriticaService from "../../../services/AnaliseCriticaService";
import Footer from "../../comum/components/Footer";
import FooterContent from "../../comum/components/FooterContent";
import FooterOptions from "../../comum/components/FooterOptions";
import IconButton from "../../comum/components/IconButton";
import {makePDF} from "../../../utils/formatar";
import {IconeCarregar} from "../../comum/components/Icones";
import ExportarExcelAnalise from "../components/ExportarExcelAnalise";
import {ModalAnaliseCriticaForm} from "../components/ModalAnaliseCriticaForm";
import ModalObsFluxo from '../components/ModalObsFluxo';

@inject("store")
@DataWrapper
@observer
export class AnaliseCritica extends Component {
    constructor(props) {
        super(props);
        this.service = new AnaliseCriticaService();

        this.controller = new AnaliseCriticaStore(this.service);
        this.controllerFiltro = new FiltrosAnaliseCriticaStore(this.service);

        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Análise Crítica");
    };

    cadastrarAnaliseCritica() {
        if(this.controller.cadastrar || this.controller.editar || this.controller.enviar){
            return <ModalAnaliseCriticaForm controller={ this.controller }
                                            service={this.service}
                                            cadastrar={this.controller.cadastrar}
                                            editar={this.controller.editar}
                                            enviar={this.controller.enviar} />
        }
    };

    modalObsFluxo() {
        if(this.controller.modalObsFluxo){
            return <ModalObsFluxo controller={this.controller} />
        }
    }

    render() {
        let pdfData = this.controller.colunasExportacao;
        let pdfDataTime = pdfData.filter(elem => elem.formatter && elem.formatter.name === 'formatarDataCustomHTML');

        return (
            <div className="form-wrapper">

                { this.cadastrarAnaliseCritica() }
                { this.modalObsFluxo() }
                <Container className="analise-critica tela-botoes-inclusao-topo" fluid>
                    <Row className="botoes-inclusao-topo">
                        <Col xs={12} sm={12} md={12} >
                            <Button onClick={ () => this.controller.alternarModalCadastrar() } className="btn-com-bordas-primary">Nova Análise</Button>
                        </Col>
                    </Row>
                    <FiltrosAnaliseCritica controllerFiltro={this.controllerFiltro} controllerAnalise={this.controller} />
                    <TabelaAnaliseCritica controller={this.controller} />
                </Container>

                <Footer>
                    <FooterContent>
                        <div className="justify-content-between">
                            <div>
                                <b>{this.controller.items.length}</b> Registros no Total
                                { this.controller.estadoFiltros &&
                                    <React.Fragment>
                                       - <a onClick={ () => this.controller.reListar() } >Atualizar Lista</a>
                                    </React.Fragment>
                                }
                            </div>
                        </div>
                    </FooterContent>
                    <FooterOptions>
                        <div>
                            <IconButton
                                icon="file-pdf"
                                text="Baixar PDF"
                                size="md"
                                disabled={this.controller.analiseLista.length===0}
                                onClick={
                                    () => this.controller.analiseLista.length > 0 ?
                                        makePDF(
                                        this.controller.analiseLista,
                                        pdfData.map(elem => elem.dataField),
                                        pdfData.map(elem => elem.text),
                                        pdfDataTime.map(elem => elem.dataField),
                                        false,
                                        true,
                                        {nomeDoArquivo: "AnaliseCritica.pdf"})
                                        : {}
                                }
                            />
                        </div>
                        <div>
                            <ExportarExcelAnalise controller={this.controller}/>
                        </div>
                    </FooterOptions>
                    <FooterContent className="right-pos">
                        <div>
                            { this.controller.salvando &&
                                <IconeCarregar tamanho="2x" cor="#001C43" />
                            }
                        </div>
                    </FooterContent>
                </Footer>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/analise/tela/AnaliseCritica.js